import React, { useState, useEffect } from 'react';
import { Box, Grid, AppBar, Toolbar, Typography, List, ListItem, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles'; // Import useTheme
import Profile from './Profile';
import Prediction from './Prediction';
import UserInfo from './UserInfo';
import AddListing from './AddListing';
import OwnListings from './OwnListings';
import StatsForm from './StatsForm';


import OwnPredictions from './OwnPredictions';
import AddHomeOutlinedIcon from '@mui/icons-material/AddHomeOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Mymenu = (props) => {
  const theme = useTheme();
  const authHeaders = props.user;
  const bUrl = props.backEnd;
  const [activeContent, setActiveContent] = useState('Начало');
  const [loading, setLoading] = useState(true)

  const [formData, setFormData] = useState({
      firstname: '',
      lastname: '',
      position: '',
      email: '',
      password: '',
    });
  
    useEffect(() => {
  
      const fetchUserDetails = async () => {
        try {
          const response = await fetch( bUrl + 'get_user_details', {
            method: 'GET',
            headers: {
              Authorization: authHeaders,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch user details');
          }
  
          const data = await response.json();
          setFormData({
            firstname: data.firstname || '',
            lastname: data.lastname || '',
            position: data.position || '',
            email: data.email || '',
            password: '', // Keep password empty as required
          });
        } catch (error) {
          console.error('Error fetching user details:', error);
          localStorage.removeItem('smartval')
          window.location.reload(); 
        }
        setLoading(false)
      };
  
      fetchUserDetails();
    }, [authHeaders, bUrl]);

  // const menuItems = [
  //   'Начало', 'Профил', 'Детайли', 'Прогнозна оценка', 'Генерирани оценки', 'Добави обява', 'Лични обяви', 'Статистика'
  // ];

   const menuItems = [
    'Начало', 'Нова оценка', 'Моите оценки', 'Анализи', 'Настройки', 'Детайли',    'Моите имоти', 
  ];

  const contentComponents = {
    'Настройки': <Profile authHeaders={authHeaders} backEnd={bUrl} />,
    'Кредити': <UserInfo authHeaders={authHeaders} backEnd={bUrl} />,
    'Нова оценка': <Prediction authHeaders={authHeaders} backEnd={bUrl} />,
    'Моите оценки': <OwnPredictions authHeaders={authHeaders} backEnd={bUrl} />,
    'Добави обява': <AddListing authHeaders={authHeaders} backEnd={bUrl} />,
    // 'Лични обяви': <OwnListings authHeaders={authHeaders} backEnd={bUrl} />,
    'Анализи': <StatsForm authHeaders={authHeaders} backEnd={bUrl} />
  };


 if (loading) {
  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <span>Loading...</span>
    </div>
  );
}

  return (
    <div className="my_menu" style={{ width: '100%', backgroundColor: '#FFFFFF', overflowY: 'auto', maxHeight: '60vh' }}>
      <Grid container sx={{ height: '100vh' }}>
        
        {/* Sidebar */}
        <Grid
          item
          xs={12}
          sm={2}
          md={1.5}
          sx={{
            // backgroundColor: '#f0f0f0',/
            borderRight: '1px solid #ddd',
          }}
        >
          <Box sx={{ height: '100%', overflow: 'auto', padding: 1 }}>
            <List>
               <ListItem sx={{p: 0,
  pl: 1,}}>
    <Button
      fullWidthj43
      startIcon={<AddHomeOutlinedIcon />}
      variant={activeContent === 'Начало' ? 'contained' : 'outlined'}
      onClick={() => setActiveContent('Начало')}
      sx={{
        margin: 1,
        textTransform: 'none',
        border: 'none',
        color: activeContent === 'Home' ? '#1CA6AF' : '#1CA6AF',
      }}
    >
      Начало
    </Button>
   
  </ListItem>
  <ListItem sx={{p: 0,
  pl: 1,}}>
 <Button
      fullWidthj43
      startIcon={<AddOutlinedIcon />}
      variant={activeContent === 'Нова оценка' ? 'contained' : 'outlined'}
      onClick={() => setActiveContent('Нова оценка')}
      sx={{
        margin: 1,
        textTransform: 'none',
        border: 'none',
        color: activeContent === 'Нова оценка' ? '#1CA6AF' : '#1CA6AF',
      }}
    >
      Нова оценка
    </Button>
  </ListItem>
  <ListItem sx={{p: 0,
  pl: 1,}}>
 <Button
      fullWidthj43
      startIcon={<FormatListNumberedOutlinedIcon />}
      variant={activeContent === 'Моите оценки' ? 'contained' : 'outlined'}
      onClick={() => setActiveContent('Моите оценки')}
      sx={{
        margin: 1,
        textTransform: 'none',
        border: 'none',
        color: activeContent === 'Моите оценки' ? '#1CA6AF' : '#1CA6AF',
      }}
    >
      Моите оценки
    </Button>
  </ListItem>
   <ListItem sx={{p: 0,
  pl: 1,}}>
 <Button
      fullWidthj43
      startIcon={<QueryStatsOutlinedIcon />}
      variant={activeContent === 'Анализи' ? 'contained' : 'outlined'}
      onClick={() => setActiveContent('Анализи')}
      sx={{
        margin: 1,
        textTransform: 'none',
        border: 'none',
        color: activeContent === 'Анализи' ? '#1CA6AF' : '#1CA6AF',
      }}
    >
      Анализи
    </Button>
  </ListItem>
  <ListItem sx={{p: 0,
  pl: 1,}}>
 <Button
      fullWidthj43
      startIcon={<SettingsOutlinedIcon />}
      variant={activeContent === 'Настройки' ? 'contained' : 'outlined'}
      onClick={() => setActiveContent('Настройки')}
      sx={{
        margin: 1,
        textTransform: 'none',
        border: 'none',
        color: activeContent === 'Настройки' ? '#1CA6AF' : '#1CA6AF',
      }}
    >
      Настройки
    </Button>
  </ListItem>
  <ListItem sx={{p: 0,
  pl: 1,}}> 
 <Button
      fullWidthj43
      startIcon={<SavingsOutlinedIcon />}
      variant={activeContent === 'Кредити' ? 'contained' : 'outlined'}
      onClick={() => setActiveContent('Кредити')}
      sx={{
        margin: 1,
        textTransform: 'none',
        border: 'none',
        color: activeContent === 'Кредити' ? '#1CA6AF' : '#1CA6AF',
      }}
    >
      Кредити
    </Button>
  </ListItem>
              {/* {menuItems.map((text) => (
                <ListItem key={text} disablePadding sx={{ justifyContent: 'center' }}>
                  <Button
                    fullWidth
                    variant={activeContent === text ? 'contained' : 'outlined'}
                    onClick={() => setActiveContent(text)}
                    sx={{
                      margin: 1,
                      // borderRadius: 2,
                      textTransform: 'none',
                      border: 'none',
                      // backgroundColor: activeContent === text ? '#1CA6AF' : '#fff',
                      color: activeContent === text ? '#1CA6AF' : '#1CA6AF',
                      // '&:hover': {
                      //   backgroundColor: '#1CA6AF',
                      //   color: '#fff'
                      // }
                    }}
                  >
                    {text}
                  </Button>
                </ListItem>
              ))} */}
            </List>
          </Box>
        </Grid>

        {/* Content Area */}
        <Grid item xs={12} sm={9} md={10.5}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            {/* Top Bar */}
            <AppBar
              position="static"
              sx={{
                backgroundColor: '#1CA6AF',
                zIndex: 1,
              }}
            >
              <Toolbar sx={{ backgroundColor: theme.palette.primary.another }}>
                <Typography variant="h6" noWrap>
                  Контролен панел
                </Typography>
              </Toolbar>
            </AppBar>

            {/* Main Content */}
            <Box
              sx={{
                flexGrow: 1,
                padding: 3,
                overflow: 'auto',
                backgroundColor: theme.palette.primary.main
              }}
            >
              {contentComponents[activeContent] || (
               <Box>             
               <Typography variant="body1" gutterBottom sx={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>
                 Добре дошли в контролния панел! Използвайте менюто вляво, за да навигирате през функциите.
               </Typography>
             
               <Box sx={{ marginTop: 2 }}>
                 <Accordion>
                   <AccordionSummary
                     expandIcon={<ExpandMoreIcon />}
                     aria-controls="panel1-content"
                     id="panel1-header"
                   >
                     <Typography>Как да редактирате профила си?</Typography>
                   </AccordionSummary>
                   <AccordionDetails>
                     <Typography>
                       След избиране на "Профил" от менюто, Вие ще имат възможност да редактирате вашите лични данни. Всички полета подлежат на редакция с изключение на полето 'Позиция'
                     </Typography>
                   </AccordionDetails>
                 </Accordion>

                 <Accordion>
                   <AccordionSummary
                     expandIcon={<ExpandMoreIcon />}
                     aria-controls="panel1-content"
                     id="panel1-header"
                   >
                     <Typography>Как бързо да проверя кредит баланса на моя профил?</Typography>
                   </AccordionSummary>
                   <AccordionDetails>
                     <Typography>
                      Бутонът "Детайли" Ви предоставя допълнителна информация, за брой кредити, прогнози и обяви, които сте въвели в систематас
                     </Typography>
                   </AccordionDetails>
                 </Accordion>

                 <Accordion>
                   <AccordionSummary
                     expandIcon={<ExpandMoreIcon />}
                     aria-controls="panel2-content"
                     id="panel2-header"
                   >
                     <Typography>Как да направите прогнозна оценка?</Typography>
                   </AccordionSummary>
                   <AccordionDetails>
                     <Typography>
                       Отидете на "Прогнозна оценка". Системата ще Ви зареди бланка с полета, които да попълните. Колкото повече детайли посочите, толкова по-точна ще бъде оценката на модела.
                       В допълнение, ще получите автоматично и средни цени за града и квартала. Това ще Ви даде представа и за общото състояние на имотния пазар. 
                     </Typography>
                   </AccordionDetails>
                 </Accordion>
             
                 <Accordion>
                   <AccordionSummary
                     expandIcon={<ExpandMoreIcon />}
                     aria-controls="panel2-content"
                     id="panel2-header"
                   >
                     <Typography>Как да добавите нова обява?</Typography>
                   </AccordionSummary>
                   <AccordionDetails>
                     <Typography>
                       Отидете на "Добави обява", попълнете формата и натиснете "Запази".
                     </Typography>
                   </AccordionDetails>
                 </Accordion>
             
                 <Accordion>
                   <AccordionSummary
                     expandIcon={<ExpandMoreIcon />}
                     aria-controls="panel3-content"
                     id="panel3-header"
                   >
                     <Typography>Как да видите вашите обяви?</Typography>
                   </AccordionSummary>
                   <AccordionDetails>
                     <Typography>
                       Изберете "Лични обяви", за да прегледате, редактирате или изтриете вече създадени обяви.
                     </Typography>
                   </AccordionDetails>
                 </Accordion>
             
                 <Accordion>
                   <AccordionSummary
                     expandIcon={<ExpandMoreIcon />}
                     aria-controls="panel4-content"
                     id="panel4-header"
                   >
                     <Typography>Как да прегледате нашите статистики</Typography>
                   </AccordionSummary>
                   <AccordionDetails>
                     <Typography>
                       Изберете "Статистика". От бланката ще можете да изберете град, квартал и период за отчет. Като резултат, ще имате цени и средни стойности в таблична форма, както и визуализация на цените през избрания период. Ако пропуснете да изберете квартал, то системата ще извлече статистика, за всички квартали на посочения град.
                     </Typography>
                   </AccordionDetails>
                 </Accordion>
             
               </Box>
             </Box>
             
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
 
    </div>
    
  );
};

export default Mymenu;
